import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-layout',
  templateUrl: './home-layout.component.html',
  styleUrls: ['./home-layout.component.scss'],
  standalone: false,
})
export class HomeLayoutComponent implements OnInit {
  titleObj: any = {};
  localMessage: any = {};

  constructor() {}

  ngOnInit() {}

  skipContentFocusAdd() {
    document.body.classList.add('skip-body-focus');
  }

  skipContentFocusRemove() {
    document.body.classList.remove('skip-body-focus');
  }
}
